import $ from 'jquery';
import page from '../../smartpak/page';

var saleKentico = {
    _bindMobileEvents: function() {
        var isMobile = page.isMobile();

        if (isMobile) {
            $('.showCategory').on('click', function(e) {
                e.preventDefault();
                var $element = $(e.target)
                    .closest('div')
                    .find('ul');

                $element.toggle();
            });

            $('.brands').on('click', function(e) {
                e.preventDefault();
                var $element = $(e.target).next('ul');

                $element.toggle();
            });
        }
    }
};

export default saleKentico;
